import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function usePostState() {
  return useAppState();
}

export function usePostActions(postId) {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((state) => ({
      ...state,
      posts: {
        ...state.posts,
        [postId]: {
          expanded: false,
          subTextContainerIsLongerThanTextContainer: false,
        },
      },
    }));
  }

  function setExpanded(expanded) {
    dispatch((state) => ({
      ...state,
      posts: {
        ...state.posts,
        [postId]: {
          ...state.posts?.[postId],
          expanded,
        },
      },
    }));
  }

  function setSubTextContainerIsLongerThanTextContainer(isLonger) {
    dispatch((state) => ({
      ...state,
      posts: {
        ...state.posts,
        [postId]: {
          ...state.posts?.[postId],
          subTextContainerIsLongerThanTextContainer: isLonger,
        },
      },
    }));
  }

  function onError(feedback) {
    dispatch((state) => ({
      ...state,
      feedbackMessage: feedback.feedbackMessage || null,
      feedbackVariant: feedback.feedbackVariant || null,
    }));
  }

  return {
    initializeState,
    setExpanded,
    setSubTextContainerIsLongerThanTextContainer,
    onError,
  };
}
